// extracted by mini-css-extract-plugin
module.exports = {"custom":"_4e8e79493743d5d59d43695091602992-less"};